import type { PropsWithChildren } from 'react'
import { createContext, useCallback, useEffect, useMemo, useRef } from 'react'

interface RateImpressionContextValue {
  hasFired: (key: string) => boolean
  markAsFired: (key: string) => void
}

const RateImpressionContext = createContext<RateImpressionContextValue>({
  hasFired: () => false,
  markAsFired: () => {},
})

interface Props {
  availabilityKey?: string
}

export function RateImpressionProvider(props: PropsWithChildren<Props>) {
  const { availabilityKey, children } = props
  const firedImpressions = useRef<Set<string>>(new Set())

  useEffect(() => {
    firedImpressions.current = new Set()
  }, [availabilityKey])

  const hasFired = useCallback((key: string) => {
    return firedImpressions.current.has(key)
  }, [])

  const markAsFired = useCallback((key: string) => {
    firedImpressions.current.add(key)
  }, [])

  const value = useMemo<RateImpressionContextValue>(() => ({
    hasFired,
    markAsFired,
  }), [hasFired, markAsFired])

  return <RateImpressionContext.Provider value={value}>
    {children}
  </RateImpressionContext.Provider>
}

export default RateImpressionContext
